<template>
  <div>
    <!-- <div>

      <md-button class="md-just-icon md-round md-danger"  @click="newServer">
        <md-icon>add</md-icon>
      </md-button>
    </div>-->
    <md-card v-for="server in servers" :key="server._id">
      <md-card-header>
        <router-link :to="{path:'/server?id='+server._id}">
          <div class="md-title">
            <span>{{server.name}}</span>
          </div>
        </router-link>
      </md-card-header>

      <md-card-actions>
        <md-button
          :data-clipboard-text="server.user"
          class="md-round clipboard"
          title="copiar usuario"
        >
          <md-icon>person</md-icon>
          {{server.user}}
        </md-button>
        <md-button
          :data-clipboard-text="server.password"
          class="md-round clipboard"
          title="copiar contraseña"
        >
          <md-icon>lock</md-icon>
          {{server.password}}
        </md-button>
        <md-button
          :data-clipboard-text="server.ip.public"
          class="md-round clipboard"
          title="copiar ip publica"
        >
          <md-icon>storage</md-icon>
          {{server.ip.public}}
        </md-button>
      </md-card-actions>
    </md-card>
    <Ftb></Ftb>
  </div>
</template>
<script>
import axios from "axios";
import api from "../../../lib/api.js";
import { mapMutations, mapActions } from "vuex";
import Ftb from "../Components/Ftb";
export default {
  name: "Servers",
  components: { Ftb },
  data() {
    return {
      servers: []
    };
  },
  mounted() {
    // new ClipboardJS(".clipboard");
    axios(`${api()}/servers`)
      .then(res => {
        this.servers = res.data.docs;
      })
      .catch(err => {
        console.warn(err);
      });
  },
  computed: {},
  methods: {
    ...mapMutations({
      clear: "servers/clear"
    }),
    // copyText(element) {
    //   copy(element, true);
    // },
    newServer() {
      this.clear();
      this.$router.push("/server");
    }
  }
};
</script>
<style scoped>
.md-card.card-inline {
  width: 600px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.md-button.md-just-icon {
  margin-left: 5px;
}
.hide {
  display: none;
}
.inputButton {
  color: inherit;
  background: transparent;
  border: none;
  cursor: pointer !important;
}
.md-field.hideField {
  opacity: 0;
  margin-left: -9999;
}
.md-title {
  color: black;
}
</style>
